import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import Restricted from "src/app/Restricted";
import PATHS, { url } from "src/consts/urlPaths";

type GuardrailsLinkProps = {
  children?: ReactNode;
  item: { name?: string };
  className?: string;
};

const GuardrailsLink = ({ children, item, className }: GuardrailsLinkProps) => (
  <Restricted>
    <Link
      id="guardrails-nav-link"
      to={url(PATHS.WORKFORCE_PLANNING_GUARDRAILS)}
      aria-label={item.name}
      className={className}
    >
      {children}
    </Link>
  </Restricted>
);

export default GuardrailsLink;
